import { render, staticRenderFns } from "./AdminInquiryDetail.vue?vue&type=template&id=48f17d26&scoped=true"
import script from "./AdminInquiryDetail.vue?vue&type=script&lang=js"
export * from "./AdminInquiryDetail.vue?vue&type=script&lang=js"
import style0 from "./AdminInquiryDetail.vue?vue&type=style&index=0&id=48f17d26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f17d26",
  null
  
)

export default component.exports